import { AllCommunityModule, ModuleRegistry, themeQuartz, TooltipModule } from 'ag-grid-community'; 
import { createGrid } from 'ag-grid-community';
import abbreviate from './abbreviate';
import slugify from 'slugify';


export default (data) => {
    // Register all Community features
    ModuleRegistry.registerModules([AllCommunityModule, TooltipModule]);

    const columnMaker = () => {
        let columns = Object.keys(data[Object.keys(data)[0]].meta).map(category => {
            return {
                field: category,
                headerTooltip: category,
                headerName: abbreviate(category),
                // columnGroupShow: "open",
                valueFormatter: params => params.value === '0' ? '' : params.value,
                cellClass: params => {
                    return params.value === '0' ? 'greyed-out' : '';
                },
            }
        })
        return columns
    }


    const rowMaker = () => {
        let rows = Object.keys(data).map(collection => {
            let c = {}
            c.title = {
                title: collection,
                slug: slugify(collection)
            }
            c.total = 0
            Object.keys(data[collection].meta).map(category => {
                c[category] = data[collection].meta[category]
                c.total += parseInt(data[collection].meta[category])
            })  
            return c
        })
        return rows
    }



    




    const myTheme = themeQuartz.withParams({
        // wrapperBorder: false, 
    })

    // Grid Options: Contains all of the Data Grid configurations
    const gridOptions = {
        theme: myTheme,
        domLayout: 'autoHeight',
        tooltipShowDelay: 0,
        tooltipHideDelay: 2000,

        defaultColDef: {
            resizable: true,
        },

        autoSizeStrategy: {
            type: 'fitGridWidth',
            defaultMinWidth: 100,
            columnLimits: [
            {
                colId: 'title',
                minWidth: 250
            }
        ]
        },

        
        // Column Definitions: Defines the columns to be displayed.
        columnDefs: [
             {
                headerName: 'Witnesses',
                lockPosition: 'left',
                
                children: [
                    { field: 'title',  pinned: 'left', cellStyle: { fontWeight: 'bold' }, filter: true, cellRenderer: params => {
                    return `
                    <div class="title-cell">
                        <a href="/collection/${params.value.slug}" class="ag-btn">
                        ${params.value.title}
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="6" cy="6" r="6" fill="#EB131B"/>
                                <path d="M5 8.25L8 6.125L5 4" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </a>
                    </div>
                    `}, valueFormatter: params => params.value.title,},
                ]
            },
            {
                headerName: 'Categories',
                children: [{
                    field: 'total',
                    // columnGroupShow: "closed"
                }, ...columnMaker()],
            }
        ],


        // Row Data: The data to be displayed.
        rowData: rowMaker(),
        
    };

   
    // Your Javascript code to create the Data Grid
    const myGridElement = document.querySelector('#variation-ag-container');
    createGrid(myGridElement, gridOptions);
}